var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOperatingHistory = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.46,14.29 A 8.84,8.84 0 0,1 14.29,3.46",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.21,2 L 14.29,3.46 L 12.63,4.18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.54,9.71 A 8.84,8.84 0 0,1 9.71,20.54",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.79,22 L 9.71,20.54 L 11.37,19.82",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.84,11.08 L 15.68,11.08 A 0.92,0.92 0 0,1 15.68,12.92 L 13.84,12.92 L 12,16.14 L 10.62,16.14 L 11.54,12.92 L 9.7,12.92 L 8.78,13.84 L 7.4,13.84 L 8.32,12 L 7.4,10.16 L 8.78,10.16 L 9.7,11.08 L 11.54,11.08 L 10.62,7.86 L 12,7.86 L 13.84,11.08",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOperatingHistory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/operating-history.adb54ab7.svg";
export { ForwardRef as ReactComponent };